import React from "react";
import PrescriptionModeration from "../../components/Admin/Prescription/PrescriptionModeration";

const PrescriptionModerationPage = () => {
    return (
        <section className="w-full">
            <PrescriptionModeration />
        </section>
    );
};

export default PrescriptionModerationPage;
